
import { useEffect } from 'react';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import WhyChooseSection from './components/WhyChooseSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import StatsSection from './components/StatsSection';
import ServiceAreaSection from './components/ServiceAreaSection';
import CTA1Section from './components/CTA1Section';
import CTA2Section from './components/CTA2Section';
import CTA3Section from './components/CTA3Section';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // SEO Configuration
  useSEO({
    title: "J's Landscaping - Professional Landscaping Services in Harford County, MD",
    description: "J's Landscaping provides professional landscaping services in Harford County, Maryland. Expert lawn care, hardscaping, landscape design, mulching, tree services, and complete property management with over 15 years of experience.",
    keywords: "landscaping Harford County, lawn care Maryland, hardscaping services, landscape design, mulching services, tree services, property management, J's Landscaping",
    canonical: "/",
    ogImage: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/og-image.jpg`,
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateLocalBusinessSchema(),
        generateWebPageSchema(
          "J's Landscaping - Professional Landscaping Services in Harford County, MD",
          "J's Landscaping provides professional landscaping services in Harford County, Maryland. Expert lawn care, hardscaping, landscape design, mulching, tree services, and complete property management with over 15 years of experience.",
          "/"
        )
      ]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ServicesSection />
      <CTA1Section />
      <AboutSection />
      <WhyChooseSection />
      <HowItWorksSection />
      <CTA2Section />
      <TestimonialsSection />
      <StatsSection />
      <ServiceAreaSection />
      <CTA3Section />
      <Footer />
    </div>
  );
}
